import React from "react";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import isMobile from "ismobilejs";
import classnames from "classnames";
import { isAnswer } from "utils/formatter";
import storage from "utils/storage";
import Dialog, {
  DialogActions,
  DialogContent
} from "material-ui/Dialog";
import Typography from "material-ui/Typography";

const browserStyles = theme => ({
  container: {
    margin: 20,
    padding: 20,
    backgroundColor: theme.palette.answer.backgroundColor,
    height: 715,
    position: "relative"
  },
  main: {
    padding: 20
  },
  labelDiv: {
    height: 222,
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
  },
  label: {
    fontSize: "1.6rem",
    padding: "3px 20px"
  },
  charCounter: {
    textAlign: "right",
    width: 240,
    float: "right",
    color: "gray",
    marginTop: 30
  },
  charLabel: {
    float: "left"
  },
  charCount: {
    float: "right"
  },
  overChar: {
    color: theme.palette.error[600]
  },
  textarea: {
    resize: "none",
    width: "100%",
    height: 250,
    fontSize: "1.1rem",
    color: "#1f1845",
    border: "1px solid lightgray",
    borderRadius: 5,
    padding: "5px 10px"
  },
  annotate: {
    textAlign: "right",
    color: theme.palette.primary.main,
    fontSize: "0.9rem"
  },
  nextBtnDiv: {
    marginTop: 5,
    textAlign: "center"
  },
  nextBtn: {
    marginTop: 70
  },
  footer: {
    position: "absolute",
    bottom: 15,
    margin: 10,
    width: "95%"
  },
  clear: {
    clear: "both"
  },
  btnGroup: {
    display: "flex",
    justifyContent: "space-between"
  },
  tempSaveBtn: {
    display: "flex",
  }
});

const mobileStyles = theme => ({
  container: {
    margin: 10,
    padding: 10,
    backgroundColor: theme.palette.answer.backgroundColor
  },
  label: {
    padding: "3px 10px"
  },
  charCounter: {
    fontSize: ".9rem",
    color: "gray",
    marginTop: 20
  },
  charLabel: {},
  charCount: {
    width: 93
  },
  overChar: {
    color: theme.palette.error[600]
  },
  textarea: {
    resize: "none",
    width: "92%",
    height: 100,
    color: "#1f1845",
    border: "1px solid lightgray",
    borderRadius: 5,
    padding: "5px 10px",
    fontSize: "1.1rem"
  },
  annotate: {
    color: theme.palette.primary.main,
    fontSize: "0.8rem"
  },
  nextBtnDiv: {
    margin: 20,
    textAlign: "center"
  },
  nextBtn: {
    marginTop: 10
  }
});

class AnswerAttribute extends React.Component {
  state = {
    temporarySave: false,
    showSavedDialog: false,
  };

  openTemporarySaveDialog = () => {
    this.setState({ temporarySave: true });
  };

  closeTemporarySaveDialog = () => {
    this.setState({ temporarySave: false });
  };

  confirmTemporarySave = () => {
    const { answerResult, locale } = this.props;
    const { attrResult, basicResult, additionResult } = answerResult;
  
    const params = {
      tempSavedPath: "/other",
      attrResult,
      basicResult,
      additionResult,
      localeId: locale.id,
      freeComment1: answerResult.freeComment1,
      freeComment2: answerResult.freeComment2,
      url: storage.getUrlToken(),
      token: storage.getToken(),
      survey_id: storage.getSurveyId(),
    };
    window.removeEventListener('beforeunload', this.showReloadAlert);
    this.props.startTemporarySave(params)
      .then(() => {
        this.setState({ temporarySave: false, showSavedDialog: true });
      })
      .catch(() => {});
  };

  componentWillMount() {
    const { answerToken } = this.props.answerHeader;

    if (answerToken) {
      if (isAnswer()) {
        window.addEventListener("beforeunload", this.showReloadAlert);
      }
    } else {
      // answerTokenなしは認証エラー
      this.props.showErrorDialog();
    }
  }

  componentWillUnmount() {
    if (isAnswer()) {
      window.removeEventListener("beforeunload", this.showReloadAlert);
    }
  }

  showReloadAlert(e) {
    e.returnValue = "回答は削除されます。";
  }

  render() {
    // 認証トークンがなければ画面の描写をしない
    if (!this.props.answerHeader.answerToken) {
      return null;
    }
    const { location } = this.props;
    const { classes, answerOther, freeComments } = this.props;
    const { currentPage, freeCommentDescriptions, btnLabel } = answerOther; // state

    const { handleNextBtn, handlePrevBtn, changeFreeCommentText } = this.props; // action

    const freeCommentDescription = freeCommentDescriptions[currentPage];
    const freeComment = freeComments[currentPage];

    const maxChar = 400;
    const restChar = maxChar - freeComment.length;
    const invalid = restChar < 0;

    return (
      <div>
        <Dialog
          open={this.state.temporarySave}
          onClose={this.closeTemporarySaveDialog}
          PaperProps={{
            style: { padding: '30px', borderRadius: '8px' },
          }}
        >
          <DialogContent
            style={{
              marginTop: '10px',
              textAlign: 'center',
              borderBottom: 'none',
            }}
          >
            <Typography variant='body1' style={{ fontSize: '1.6rem' }}>
              回答を一時保存して中断します。
              <br />
              よろしいですか？
            </Typography>
          </DialogContent>

          <DialogActions
            style={{ justifyContent: 'space-between', padding: '20px' }}
          >
            <Button raised onClick={this.closeTemporarySaveDialog}>
              キャンセル
            </Button>
            <Button raised onClick={this.confirmTemporarySave}>
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.showSavedDialog}
          onClose={() => {}}
          disableBackdropClick
          disableEscapeKeyDown
          PaperProps={{
            style: { padding: '30px', borderRadius: '8px' },
          }}
        >
          <DialogContent style={{ textAlign: 'center', borderBottom: 'none' }}>
            <Typography variant='body1' style={{ fontSize: '1.6rem' }}>
              一時保存しました。
            </Typography>
          </DialogContent>

          <DialogActions style={{ justifyContent: 'center', paddingTop: 20 }}>
            <Button
              raised
              style={{ padding: '10px 50px' }}
              onClick={() => {
                this.setState({ showSavedDialog: false });
                this.props.confirmedTemporarySave();
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Paper className={classes.container}>
          <div className={classes.main}>
            <div className={classes.labelDiv}>
              <span className={classes.label}>{freeCommentDescription}</span>
            </div>

            <div
              className={classnames(
                classes.charCounter,
                invalid ? classes.overChar : ''
              )}
            >
              <span className={classes.charLabel}>入力可能文字数：</span>
              <span className={classes.charCount}>
                {restChar} / {maxChar}
              </span>
            </div>

            <textarea
              id='free-comment'
              value={freeComment}
              onChange={(e) =>
                changeFreeCommentText(currentPage, e.target.value)
              }
              className={classes.textarea}
              wrap='hard'
            />
            <div className={classes.annotate}>
              ※個人を特定できる情報（個人のお名前など）の入力はご遠慮ください。
            </div>
          </div>

          <div className={classes.nextBtnDiv}>
            <Button
              raised
              disabled={invalid}
              onClick={handleNextBtn(answerOther)}
            >
              {btnLabel}
            </Button>
          </div>

          <div className={classes.footer}>
          <div className={classes.btnGroup}>
            <Button raised dense onClick={handlePrevBtn(currentPage)}>
              前へ
            </Button>

            {location.pathname === '/answer/other' && this.props.answerStart.isRespondent && (
              <Button
                raised
                dense
                style={{ marginLeft: 20 }}
                onClick={this.openTemporarySaveDialog}
              >
                一時保存
              </Button>
            )}
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

export default withStyles(isMobile.any ? mobileStyles : browserStyles)(
  AnswerAttribute
);



// WEBPACK FOOTER //
// ./src/components/answer/AnswerOther.jsx